<template lang="pug">
  .profile-page.page
    .container
      .profile-page__container
        .profile-page__side.md
          side-nav(
          v-bind:sideNavData="sideNavData"
          )
        .profile-page__main.md
          //.profile-page__header
            .profile-page__title
              h1.title Педагоги
          .profile-page__tabs
            tab-nav(
            v-bind:tabNavData="tabNavData"
            )
          .profile-page__content
            section.profile-page-form__section.profile-section
              .profile-section__title
                h2.profile-section-title Педагоги
              .profile-section__body
                .form
                  .form__elem
                    .form-elem.form-elem_horizontal
                      .form-elem__title ФИО
                      .form-elem__body
                        input.input.input_full(
                        maxlength="50"
                        value="Иванов Иван Иванович"
                        )
                  .form__elem
                    .form-elem.form-elem_horizontal
                      .form-elem__title Должность
                      .form-elem__body
                        input.input.input_full(
                        maxlength="50"
                        value="Воспитатель"
                        )
                  .form__elem.form__elem--align-right
                    button.button.button_paint-main--light
                      //.button__icon
                        img(src="@/assets/images/icons/clip.svg")
                      .button__text Добавить пункт
                  .form__elem
                    .form-elem.form-elem_horizontal
                      .form-elem__title Фотография
                      .form-elem__body
                        attach-file(
                        :attachments="passportAttachments"
                        attachment-type="passport"
                        fieldname="passport_attachments"
                          @onChangeAttachments="changeAttachments"
                        )
                        .profile__photo
                          img(src="@/assets/images/photo-upload-test/3.jpg")

                  hr.profile-section__separator
                  .form__elem.form__elem--align-right
                    button.button.button_paint-main--light
                      //.button__icon
                        img(src="@/assets/images/icons/clip.svg")
                      .button__text Добавить педагога

            section.form__elem.form__elem--align-right.form__elem_full
              button.button.button_paint-main.button_long
                .button__text Сохранить
</template>
<script>
import {mapState, mapActions} from "vuex";

import MainFooter from "@/components/footer/Footer";
import SideNav from "@/components/sideNav/SideNav";
import TabNav from "../../../../components/tabNav/TabNav.vue";
import AttachFile from "../../../../components/attach-file/AttachFile.vue";
export default {
  name: "DirectorShiftsTeachers",
  components: {
    AttachFile,
    TabNav,
    SideNav,
    MainFooter
  },
  props: ["sideNavData"],
  data() {
    return {
      tabNavData: {
        tabs: [
          {
            path: "/pages/director/shift/create",
            text: "Общая информация"
          },
          {
            path: "/pages/director/shift/quota",
            text: "Квоты"
          },
          {
            path: "/pages/director/shift/about",
            text: "Описание"
          },
          {
            path: "/pages/director/shift/program",
            text: "Программа"
          },
          {
            path: "/pages/director/shift/schedule",
            text: "Распорядок дня"
          },
          {
            path: "/pages/director/shift/teachers",
            text: "Педагоги"
          },
          {
            path: "/pages/director/shift/contacts",
            text: "Контакты"
          }
        ]
      }

    };
  },
  computed: {
    localGender: {

    }
  },
  methods: {
    onSelectItem(li) {
      this.$emit("onSelectItem", li);
      this.$emit("close");
    },
    onClickList(e) {
      e.preventDefault();
      e.stopPropagation();
    },
    onBodyClick() {
      this.$emit("close");
    }
  },
  beforeDestroy() {
    document.body.removeEventListener("click", this.onBodyClick);
  },
  created() {
    document.body.addEventListener("click", this.onBodyClick);
  }
//  computed: {
//    localDateOfBirth: {
//      get() {
//        if (!this.dateOfBirth) {
//          return "";
//        }
//        return this.dateOfBirth;
//      },
//      set() {}
//    },
//  },
//  methods: {
//    onChangeDate(date) {
//      const d = new Date(date);
//      const _date = `${d.getFullYear()}-${("0" + (d.getMonth() + 1)).slice(
//        -2
//      )}-${("0" + d.getDate()).slice(-2)}`;
//      this.$emit("onChangeValue", [_date, "date_of_birth"]);
//    },
//  }
};
</script>
